import { Button } from "../../atoms/Buttons";
import * as S from "./pedingContentItem.styles";

export const PendingContentItem = ({ f7router }: any) => {
  return (
    <S.PendingContentsItem>
      <div>
        <S.NodataItemBox>
          <p>앱 사용 권한 승인 심사 중 입니다.</p>
        </S.NodataItemBox>

        <S.MatchButtonBox>
          <Button size="full" onClick={() => window.location.replace("/")}>
            새로고침
          </Button>
        </S.MatchButtonBox>
      </div>
    </S.PendingContentsItem>
  );
};
